// WARNING: every change in this file (and used files) should also be taken into account in the static version that is served at /static/footer
import classnames from 'classnames'
import React, { useCallback } from 'react'

import {
  selectCurrentDomain,
  selectFooterData,
  selectCurrency,
  selectUrls,
} from '../../stores/selectors'
import { generateUrl } from '../../utils/url'

import { FooterLink } from './FooterLink'
import { FooterLinks } from './FooterLinks'
import { FooterTitle } from './FooterTitle'

export const Footer = () => {
  const urls = selectUrls()
  const currentDomain = selectCurrentDomain()
  const currency = selectCurrency()
  const {
    footerMenu2,
    footerMenu2Title,
    footerMenu3,
    footerMenu3Title,
    footerMenuLanguagesTitle,
    copyrightText,
  } = selectFooterData()

  const changeLanguage = useCallback(
    (href: string) => {
      document.location.href = generateUrl(href, currency)
    },
    [currency],
  )

  return (
    <footer className='footer shadow-inner footer__wrapper'>
      <div className='container'>
        <div className='flex justify-between flex-wrap'>
          <FooterLinks
            className='w-1/2 lg:w-1/4 flex-shrink-0 mb-8 lg:mb-0'
            title={footerMenu2Title}
          >
            {footerMenu2.map(({ text, href }) => (
              <FooterLink key={text} href={href}>
                {text}
              </FooterLink>
            ))}
          </FooterLinks>
          <FooterLinks
            className='w-1/2 lg:w-1/4 flex-shrink-0'
            title={footerMenu3Title}
          >
            {footerMenu3.map(({ text, href }) => (
              <FooterLink key={text} href={href}>
                {text}
              </FooterLink>
            ))}
          </FooterLinks>
          <div className='w-1/2 lg:w-1/4 flex-shrink-0'>
            <div className='footer-mt-7'>
              <FooterTitle>{footerMenuLanguagesTitle}</FooterTitle>
              <select
                id='wl-spainholiday-footer-lang-select'
                onChange={ev => changeLanguage(ev.target.value)}
                value={currentDomain.href}
                className='w-full border-2 border-solid border-white text-white outline-none footer-py-2 footer-px-4 capitalize footer-text-md'
              >
                {urls.map(({ href, isCurrentSite, languageName }) => (
                  <option
                    className={classnames(
                      isCurrentSite ? 'text-grey-dark' : 'text-black-ultra',
                    )}
                    value={href}
                    disabled={isCurrentSite}
                    key={href}
                  >
                    {languageName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className='text-center text-white footer-text-sm'>
          <p className='footer-mt-7 mb-0'> {copyrightText} </p>
        </div>
      </div>
    </footer>
  )
}
